import { Component } from '@angular/core';

@Component({
  selector: 'app-cal-rating-manager',
  templateUrl: './cal-rating-manager.component.html',
  styleUrls: ['./cal-rating-manager.component.scss']
})
export class CalRatingManagerComponent {

}
